(() => {
  const copy = JSON.parse(document.querySelector('[data-joa-native-copy]')?.textContent || '{}');
  const designCopy = JSON.parse(document.querySelector('[data-joa-global-option-copy]')?.textContent || '{}');
  const text = key => designCopy[key] || copy[key] || key;
  const expandedRows = new Map();
  const make = (tag, className, value) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (value !== undefined) node.textContent = value;
    return node;
  };
  const setText = (node, value) => { if (node && node.textContent !== value) node.textContent = value; };
  const clean = value => String(value || '').replace(/\s*-\s*(unavailable|sold out)$/i, '').trim();
  const isMetal = name => /material|metal/i.test(name);
  const rank = name => /carat|diamond.*size/i.test(name) ? 0 : /clarity|color/i.test(name) ? 1 : isMetal(name) ? 2 : /ring.*size/i.test(name) ? 4 : 3;
  const tone = value => /yellow.*white|two.?tone|2.?tone/i.test(value) ? 'two-tone' : /rose/i.test(value) ? 'rose' : /yellow/i.test(value) ? 'yellow' : 'white';
  function rows(root) { return [...root.querySelectorAll('.variant-option')]; }
  function rowName(row) {
    if (row.dataset.nativeName) return row.dataset.nativeName;
    const input = row.querySelector('input[data-option-name]');
    const label = row.querySelector('legend, :scope > label');
    const name = input?.dataset.optionName || [...(label?.childNodes || [])].filter(node => node.nodeType === Node.TEXT_NODE).map(node => node.textContent).join('').trim();
    row.dataset.nativeName = name.replace(/[:.]\s*$/, '');
    return row.dataset.nativeName;
  }
  function rowValue(row) {
    const select = row.querySelector('select');
    return clean(select ? select.value : row.querySelector('input:checked')?.value);
  }
  function styleMetal(node, value) {
    node.dataset.nativeTone = tone(value);
    let swatch = node.querySelector('.joa-native-metal-face');
    if (!swatch) { swatch = make('span', 'joa-native-metal-face'); swatch.setAttribute('aria-hidden', 'true'); node.append(swatch); }
    setText(swatch, /platinum/i.test(value) ? 'Pt' : value.match(/\d+\s*k/i)?.[0].replace(/\s/g, '').toUpperCase() || value);
  }
  function expansionKey(root, row) {
    return `${root.closest('.joa-native-editor') ? 'cart:' + (state?.url || '') : root.closest('quick-add-dialog') ? 'quick:' : 'product:'}${root.dataset.productId || ''}:${rowName(row)}`;
  }
  function setExpanded(root, row, expanded) {
    expandedRows.set(expansionKey(root, row), expanded);
    accordion(root, row, rows(root).indexOf(row));
  }
  function accordion(root, row, index) {
    const name = rowName(row);
    if (!name || !row.querySelector('input,select')) return;
    const kind = isMetal(name) ? 'metal' : /carat|diamond.*size/i.test(name) ? 'diamond' : /clarity|color/i.test(name) ? 'clarity' : /ring.*size/i.test(name) ? 'ring' : 'other';
    const label = kind === 'metal' ? text('config_metal') : kind === 'ring' ? text('config_ring_size') : kind === 'clarity' ? text('config_clarity_color') : name;
    const key = `${root.closest('.joa-native-editor') ? 'cart:' + (state?.url || '') : root.closest('quick-add-dialog') ? 'quick:' : 'product:'}${root.dataset.productId || ''}:${name}`;
    let header = row.querySelector(':scope > .joa-config-row');
    if (!header) {
      header = make('div', 'joa-config-row');
      const icon = make('span', 'joa-config-icon'); icon.innerHTML = window.JoaOptionDesign?.icon(kind) || '';
      const title = make('span', 'joa-config-title', label);
      const value = make('span', 'joa-config-value');
      const chevron = make('span', 'joa-config-chevron'); chevron.setAttribute('aria-hidden', 'true');
      const toggle = make('button', 'joa-config-toggle'); toggle.type = 'button';
      header.append(icon, title, value, chevron, toggle);
      const heading = row.querySelector('.joa-native-option__heading');
      if (heading) heading.after(header); else row.prepend(header);
      row.addEventListener('invalid', () => setExpanded(root, row, true), true);
    }
    const single = row.querySelectorAll('input[type=radio]').length === 1 || row.querySelector('select')?.options.length === 1;
    const expanded = expandedRows.has(key) ? expandedRows.get(key) : single || index === 0;
    row.classList.add('joa-config-option'); row.dataset.joaExpanded = String(expanded);
    row.dataset.nativeKind = kind;
    const value = /not sure|confirm later/i.test(rowValue(row)) ? text('config_confirm_later') : rowValue(row);
    setText(header.querySelector('.joa-config-title'), label);
    setText(header.querySelector('.joa-config-value'), value);
    const toggle = header.querySelector('button');
    toggle.setAttribute('aria-label', `${label}${value ? ': ' + value : ''}`); toggle.setAttribute('aria-expanded', String(expanded));
    const controls = [...row.children].filter(node => !node.matches('.joa-native-option__heading,.joa-config-row,style,script'));
    controls.forEach(node => { if (!node.id) node.id = `joa-native-control-${crypto.randomUUID()}`; node.classList.add('joa-native-control'); node.hidden = !expanded; });
    toggle.setAttribute('aria-controls', controls.map(node => node.id).join(' '));
    row.style.setProperty('--joa-native-count', row.querySelectorAll('.joa-native-metal').length || 1);
  }
  // Section morphing can retain nodes; resolve the current row at click time.
  document.addEventListener('click', event => {
    const toggle = event.target.closest('.joa-native-options .joa-config-toggle');
    if (!toggle) return;
    const row = toggle.closest('.variant-option'), root = row.closest('.joa-native-options');
    const key = `${root.closest('.joa-native-editor') ? 'cart:' + (state?.url || '') : root.closest('quick-add-dialog') ? 'quick:' : 'product:'}${root.dataset.productId || ''}:${rowName(row)}`;
    setExpanded(root, row, row.dataset.joaExpanded !== 'true');
  });
  function enhance(root) {
    root.classList.add('joa-native-options');
    const options = rows(root);
    options.forEach((row, index) => {
      const name = rowName(row), material = isMetal(name);
      row.classList.add('joa-native-option');
      row.dataset.nativeStep = String(index + 1).padStart(2, '0');
      row.classList.toggle('joa-native-option--metal', material);
      row.classList.toggle('joa-native-option--size', /ring.*size/i.test(name));
      const label = row.querySelector('legend, :scope > label');
      if (label) {
        label.classList.add('joa-native-option__heading');
        label.dataset.nativeStep = row.dataset.nativeStep;
        let title = label.querySelector('.joa-native-option__title');
        if (!title) {
          title = make('span', 'joa-native-option__title', material ? text('material') : name);
          [...label.childNodes].filter(node => node.nodeType === Node.TEXT_NODE).forEach(node => node.remove());
          label.prepend(title);
        }
        if (!/ring.*size/i.test(name)) {
          let value = label.querySelector('.joa-native-option__value');
          if (!value) { value = make('span', 'joa-native-option__value'); label.append(value); }
          setText(value, rowValue(row));
        }
      }
      const select = row.querySelector('select');
      const cards = !material && !/ring.*size/i.test(name) && select && select.options.length <= 50;
      if (!material && !cards) return;
      if (select) {
        row.classList.add('joa-native-option--proxy');
        const signature = [...select.options].map(option => `${option.value}:${option.disabled}`).join('|');
        let group = row.querySelector('.joa-native-metals,.joa-native-choices');
        if (!group || group.dataset.signature !== signature) {
          group?.remove(); group = make('div', cards ? 'joa-native-choices' : 'joa-native-metals'); group.dataset.signature = signature;
          group.setAttribute('role', 'group'); group.setAttribute('aria-label', material ? text('config_metal') : name);
          [...select.options].forEach(option => {
            const value = clean(option.value), button = make('button', cards ? 'joa-native-choice' : 'joa-native-metal');
            button.type = 'button'; button.dataset.value = option.value;
            button.setAttribute('aria-label', value); button.title = value; button.disabled = option.disabled;
            if (cards) setText(button, value); else styleMetal(button, value); group.append(button);
            button.addEventListener('click', () => {
              if (select.value === option.value) return;
              select.value = option.value;
              select.dispatchEvent(new Event('change', { bubbles: true }));
            });
          });
          row.append(group);
        }
        group.querySelectorAll('button').forEach(button => {
          const pressed = String(button.dataset.value === select.value);
          if (button.getAttribute('aria-pressed') !== pressed) button.setAttribute('aria-pressed', pressed);
        });
      } else {
        row.querySelectorAll('.variant-option__button-label').forEach(labelNode => {
          const input = labelNode.querySelector('input');
          if (!input) return;
          labelNode.classList.add('joa-native-metal'); labelNode.title = input.value;
          styleMetal(labelNode, input.value);
        });
      }
    });
    options.forEach((row, index) => accordion(root, row, index));
    window.JoaOptionDesign?.styleModalPayment(root.closest('.joa-config-modal'));
  }
  function enhanceProducts() {
    document.querySelectorAll('#MainContent .product-details variant-picker, quick-add-dialog variant-picker').forEach(picker => {
      if (!rows(picker).length || picker.closest('.joa-quick-ring, .mw-tingle')) return;
      const modal = picker.closest('quick-add-dialog,dialog');
      modal?.classList.add('joa-config-modal');
      enhance(picker);
      if (modal) return;
      let heading = picker.querySelector('.joa-configurator-heading');
      if (!heading) {
        heading = make('div', 'joa-configurator-heading joa-native-heading');
        heading.append(make('h2', '', text(rows(picker).some(row => /ring.*size/i.test(rowName(row))) ? 'customize_ring' : 'customize_design')));
        picker.prepend(heading);
      }
      const details = picker.closest('.product-details');
      details.setAttribute('data-joa-config-details', '');
      const ring = rows(picker).some(row => /ring.*size/i.test(rowName(row)));
      window.JoaOptionDesign?.styleEngraving(details);
      const heart = details.querySelector('.joa-product-save');
      if (heart && heart.parentElement !== heading) heading.append(heart);
      let summary = details.querySelector('.joa-native-summary');
      if (!summary) {
        summary = make('div', 'joa-native-summary joa-design-summary joa-config-total');
        summary.setAttribute('aria-live', 'polite'); summary.append(make('span', '', text(ring ? 'config_ring_total' : 'config_total')), make('p'));
        summary.querySelector('p').append(make('span', 'joa-design-summary__options'));
        picker.append(summary);
      }
      setText(summary.querySelector('.joa-design-summary__options'), rows(picker).map(row => /ring.*size/i.test(rowName(row)) ? `${text('config_ring_size')}: ${/not sure|confirm later/i.test(rowValue(row)) ? text('config_confirm_later') : rowValue(row)}` : rowValue(row)).filter(Boolean).join(' · '));
      const display = window.JoaPriceDisplay?.read(details.querySelector('product-price'));
      if (display?.current) {
        let price = summary.querySelector('.joa-design-summary__price');
        if (!price) {
          price = make('span', 'joa-design-summary__price');
          summary.querySelector('p').prepend(price);
        }
        window.JoaPriceDisplay.render(price, window.JoaPriceDisplay.add(display, details.querySelector('joa-birthstones')?.total?.() || 0));
        window.JoaOptionDesign?.stylePayment(details, display);
      }
      const downpay = details.querySelector('#downpay-block')?.closest('.shopify-app-block');
      const engraving = details.querySelector('joa-engraving') || details.querySelector('joa-birthstones');
      if (downpay && engraving && engraving.nextElementSibling !== downpay) engraving.after(downpay);
      if (downpay && summary.parentElement !== downpay) downpay.append(summary);
      document.dispatchEvent(new CustomEvent('joa:native-options-designed', { detail: { root: picker } }));
    });
    document.querySelectorAll('.joa-native-cart-options').forEach(list => {
      const sorted = [...list.children].sort((a,b) => rank(a.querySelector('dt')?.textContent || '') - rank(b.querySelector('dt')?.textContent || ''));
      sorted.forEach((row,index) => { if (list.children[index] !== row) list.insertBefore(row, list.children[index] || null); });
      sorted.forEach(row => { if (isMetal(row.querySelector('dt')?.textContent || '')) setText(row.querySelector('dt'), `${text('material')}:`); });
    });
  }
  let scheduled = false;
  const refresh = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; observer.disconnect(); enhanceProducts(); observer.observe(document.body, { subtree: true, childList: true, characterData: true }); });
  };
  const observer = new MutationObserver(refresh);
  observer.observe(document.body, { subtree: true, childList: true, characterData: true });
  document.addEventListener('change', refresh);
  document.addEventListener('joa:birthstones-change', refresh);
  refresh();

  let dialog, state, trigger;
  const route = path => `${window.Shopify?.routes?.root || '/'}cart${path}`;
  async function request(url, body) {
    const response = await fetch(url, { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) }, ...(body ? { method: 'POST', body: JSON.stringify(body) } : {}) });
    const data = await response.json();
    if (!response.ok || data.status >= 400) throw new Error(data.description || data.message || text('error'));
    return data;
  }
  function ensureDialog() {
    if (dialog) return;
    dialog = make('dialog', 'joa-native-editor joa-config-modal'); dialog.setAttribute('aria-labelledby', 'JoaNativeEditorTitle');
    const header = make('div', 'joa-cart-editor-header');
    const title = make('h2', '', text('edit')); title.id = 'JoaNativeEditorTitle';
    const close = make('button', 'joa-native-editor__close', '×'); close.type = 'button'; close.setAttribute('aria-label', text('close'));
    close.addEventListener('click', () => { if (!state?.saving) dialog.close(); });
    header.append(title, close);
    const body = make('div', 'joa-native-editor__body');
    const footer = make('div', 'joa-native-editor__footer');
    const status = make('p', 'joa-native-editor__status'); status.setAttribute('role', 'status');
    const save = make('button', 'button joa-native-editor__save', text('save')); save.type = 'button'; save.addEventListener('click', saveChanges);
    footer.append(status, save);
    if (window.JoaCompletionDate) footer.append(window.JoaCompletionDate.create(text('estimated_completion_date')));
    dialog.append(header, body, footer); document.body.append(dialog);
    dialog.addEventListener('cancel', event => { if (state?.saving) event.preventDefault(); });
    dialog.addEventListener('close', () => { state?.controller?.abort(); state = null; document.body.classList.remove('joa-native-editor-open'); trigger?.focus({ preventScroll: true }); });
    dialog.addEventListener('change', event => {
      if (!state || !event.target.matches('[data-native-option]')) return;
      const values = [...dialog.querySelectorAll('[data-native-option]')].sort((a,b) => Number(a.dataset.nativeOption) - Number(b.dataset.nativeOption)).map(select => select.selectedOptions[0].dataset.optionValueId);
      state.plan = dialog.querySelector('[name="native_selling_plan"]:checked')?.value || '';
      const variant = event.target.selectedOptions[0]?.dataset.variantId;
      loadOptions(variant ? { variant } : { option_values: values.join(',') });
    });
  }
  function status(value, error = false) {
    const node = dialog.querySelector('.joa-native-editor__status'); node.textContent = value; node.setAttribute('role', error ? 'alert' : 'status');
  }
  function busy(value) {
    dialog.querySelector('.joa-native-editor__body').setAttribute('aria-busy', String(value));
    dialog.querySelector('.joa-native-editor__save').disabled = value || !state?.available;
    dialog.querySelectorAll('[data-native-editor-options] select, [data-native-editor-options] button, .joa-native-editor__payment input').forEach(node => { node.disabled = value; });
  }
  async function loadOptions(params) {
    const current = state;
    current.controller?.abort(); current.controller = new AbortController();
    busy(true); status(text('loading'));
    try {
      const url = new URL(current.url, location.origin); url.searchParams.set('section_id', 'joa-native-editor');
      Object.entries(params).forEach(([key,value]) => url.searchParams.set(key,value));
      const response = await fetch(url, { signal: current.controller.signal, credentials: 'same-origin' });
      if (!response.ok) throw new Error(text('error'));
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = html.querySelector('[data-native-editor-content]');
      if (!content || state !== current) return;
      const body = dialog.querySelector('.joa-native-editor__body'); body.replaceChildren(content);
      const optionHost = content.querySelector('[data-native-editor-options]');
      [...optionHost.children].sort((a,b) => rank(rowName(a)) - rank(rowName(b))).forEach(row => optionHost.append(row));
      enhance(optionHost);
      current.variant = Number(content.dataset.variantId); current.available = content.dataset.available === 'true' && Boolean(current.variant);
      const plans = [...content.querySelectorAll('[name="native_selling_plan"]')];
      const selectedPlan = plans.find(input => input.value === current.plan);
      if (selectedPlan) selectedPlan.checked = true;
      else if (current.plan) { current.available = false; status(text('unavailable'), true); }
      if (current.line.properties?.Engraving) body.append(make('p', 'joa-native-editor__engraving', `${text('engraving')}: ${current.line.properties.Engraving}`));
      status(current.available ? '' : text('unavailable'), !current.available);
      busy(false);
    } catch (error) {
      if (error.name === 'AbortError' || state !== current) return;
      current.available = false; busy(false); status(text('error'), true);
    }
  }
  const planOf = item => String(item.selling_plan_allocation?.selling_plan?.id || '');
  const equalProperties = (a,b) => JSON.stringify(Object.entries(a || {}).sort()) === JSON.stringify(Object.entries(b || {}).sort());
  function matching(items, original) {
    return items.find(item => item.key === original.key) || items.find(item => item.variant_id === original.variant_id && planOf(item) === planOf(original) && equalProperties(item.properties, original.properties));
  }
  async function saveChanges() {
    const current = state;
    if (!current?.available || current.saving) return;
    current.plan = dialog.querySelector('[name="native_selling_plan"]:checked')?.value ?? current.plan ?? '';
    current.saving = true; busy(true); status(text('saving'));
    let token, removed = false;
    try {
      const snapshot = await request(route('.js'));
      const original = snapshot.items.find(item => item.key === current.line.key);
      if (!original) throw new Error(text('changed'));
      if (Number(original.variant_id) === current.variant) {
        if (planOf(original) !== current.plan) await request(route('/change.js'), { line: snapshot.items.indexOf(original) + 1, quantity: original.quantity, selling_plan: current.plan ? Number(current.plan) : null });
      } else {
        token = `${Date.now()}-${Math.random().toString(36).slice(2)}`;
        await request(route('/add.js'), { items: [{ id: current.variant, quantity: original.quantity, properties: { ...original.properties, _joa_native_edit: token }, ...(current.plan ? { selling_plan: Number(current.plan) } : {}) }] });
        const afterAdd = await request(route('.js'));
        const oldLine = matching(afterAdd.items, original);
        const replacement = afterAdd.items.find(item => item.properties?._joa_native_edit === token);
        if (!oldLine || !replacement || oldLine.quantity !== original.quantity || replacement.quantity !== original.quantity) throw new Error(text('changed'));
        const afterRemove = await request(route('/change.js'), { id: oldLine.key, quantity: 0 });
        removed = true;
        const newLine = afterRemove.items.find(item => item.properties?._joa_native_edit === token);
        if (!newLine) throw new Error(text('review'));
        const properties = { ...original.properties, _joa_native_edit: '' };
        await request(route('/change.js'), { id: newLine.key, quantity: original.quantity, properties });
      }
      location.reload();
    } catch (error) {
      if (token && !removed) {
        try {
          const cart = await request(route('.js'));
          const replacement = cart.items.find(item => item.properties?._joa_native_edit === token);
          const original = matching(cart.items, current.line);
          if (replacement && original) await request(route('/change.js'), { id: replacement.key, quantity: 0 });
          else if (replacement) removed = true;
        } catch { removed = true; }
      }
      if (removed) { location.reload(); return; }
      current.saving = false; busy(false); status(error.message || text('error'), true);
    }
  }
  document.addEventListener('click', async event => {
    const button = event.target.closest('[data-joa-native-edit]');
    if (!button) return;
    event.preventDefault(); ensureDialog(); trigger = button;
    state = { url: button.dataset.productUrl, available: false, saving: false };
    const current = state;
    dialog.querySelector('.joa-native-editor__body').replaceChildren();
    dialog.showModal(); document.body.classList.add('joa-native-editor-open'); busy(true); status(text('loading'));
    try {
      const cart = await request(route('.js'));
      if (state !== current) return;
      current.line = cart.items.find(item => item.key === button.dataset.lineKey);
      if (!current.line) throw new Error(text('changed'));
      current.plan = planOf(current.line);
      await loadOptions({ variant: String(current.line.variant_id) });
    } catch (error) { if (state === current) { busy(false); status(error.message || text('error'), true); } }
  });
})();

